import { render, staticRenderFns } from "./UsersPrivilegeClients.vue?vue&type=template&id=fcf7b22c&scoped=true&"
import script from "./UsersPrivilegeClients.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeClients.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcf7b22c",
  null
  
)

export default component.exports